import { styled } from '@innowise-group/mui-kit';

export const DatePickerContainer = styled.div`
  & .MuiTextField-root {
    width: 100%;
  }
`;
